import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/* cn — junta classes resolvendo conflitos do Tailwind (a última vence).
 *
 * ── POR QUE ISTO NÃO É O `twMerge` CRU ────────────────────────────────────
 * O `tailwind-merge` de fábrica conhece a escala TIPOGRÁFICA PADRÃO do
 * Tailwind (`text-sm`, `text-lg`…). A nossa rampa tem nome próprio
 * (`text-corpo`, `text-nota`, `text-apoio`…), e ele não tem como saber que
 * `apoio` é um tamanho: na dúvida, classifica todo `text-*` desconhecido como
 * COR. Resultado, silencioso e devastador:
 *
 *     twMerge('text-tinta-2 text-nota')  →  'text-nota'
 *
 * A cor é descartada como se fosse conflito, o elemento passa a herdar a tinta
 * do pai, e o único sintoma é "esta tela não está contrastando bem". Estava em
 * toda parte: o texto de ajuda de campo, a mensagem de erro, o cabeçalho de
 * tabela — e no botão primário, onde `text-primary-foreground` (branco) era
 * comido pelo `text-apoio` do tamanho e a letra saía na tinta escura do cartão.
 * Foi assim que o botão de avançar ficou "verde com letra preta" mesmo depois
 * de o token estar certo: o problema nunca esteve no token.
 *
 * Declarar a rampa aqui resolve na origem, para todo componente de uma vez.
 * QUALQUER degrau novo em `--text-*` (globals.css, bloco `@theme`) precisa
 * entrar nesta lista no mesmo commit, senão volta a ser lido como cor.
 */
const TAMANHOS_DE_TEXTO = [
  'micro',
  'nota',
  'apoio',
  'corpo',
  'sub',
  'secao',
  'titulo',
  'display',
] as const;

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: [...TAMANHOS_DE_TEXTO] }],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
